<template>
  <div>
    <gmap-map
      :center="center"
      :zoom="6"
      :options="mapOptions"
      class="rp-fullfillment-google-map"
    >
      <gmap-marker
        :key="index"
        v-for="(m, index) in markers"
        :position="m.position"
        @click="toggleInfoWindow(m, index)"
        :clickable="true"
      >
      </gmap-marker>
      <gmap-info-window
        :options="infoOptions"
        :position="infoWindowPos"
        :opened="infoWinOpen"
        @closeclick="infoWinOpen=false"
      >
        <div v-html="infoContent"></div>
      </gmap-info-window>
    </gmap-map>
  </div>
</template>

<script>
export default {
  name: "GoogleMap",
  props: {
    getCityAndState: {
      type: String
    },
    shippingAddress: {
      type: String
    }
  },
  data() {
    return {
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      infoContent: '',
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      infoWinOpen: false,
      // change this to whatever makes sense
      center: { lat: 45.508, lng: -73.587 },
      // default to Montreal to keep it simple
      markers: 
      [
          // {
          //   name: "Shipping address",
          //   location: this.shippingCity,
          //   position: {lat:39.933049, lng:32.858912}
          // }
      ],
      mapOptions:{
        fullscreenControl:false,
        zoomControl: false,//zoom
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        disableDefaultUi: false,
        fullscreenControl: false,//full screen
        scrollwheel: false,
        draggable:false,//draggable
      }
    };
  },

  computed: {
    getWindowInfo() {
      return this.shippingAddress.split(' ').slice(0,2).join(', ');
    }
  },

  async mounted() {
    const marker1 =  await this.getLatLngUsingAddress();
     const marker = {
        lat: marker1.lat,
        lng: marker1.lng
      };
      this.markers = [];
      this.center = marker;
      this.markers.push({
          name: "Shipping address",
          location: this.getCityAndState,
          position: marker
      })    
      await this.toggleInfoWindow(this.markers[0])
  },

  methods: {
    // receives a place object via the shipping address 
    getLatLngUsingAddress() {
      return fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${this.shippingAddress}&key=AIzaSyBjW0WBNQT8mQOLHAafXi-wvY4OZJASyvg`)
        .then(result => result.json())
        .then(result => {
          if (result.status === "OK") {
            let data = result.results[0].geometry.location
            return data
          }
        }, error => {
          console.error(error);
      });
    },
    toggleInfoWindow(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = this.getInfoWindowContent(marker);
      this.infoWinOpen = true;
    },
    getInfoWindowContent(marker) {
      return (
      ` <div class="">
          <span class="rp-google-map-pin-info">
            ${marker.name}
          </span>
            <span class="pin-info-shipping-address">${marker.location} </span>
        </div>
      `);
    }
  }
};
</script>
<style lang="scss">
.rp-fullfillment-google-map {
  width:100%; 
  height: 120px;
  @include for-size(desktop-up){
    height: 300px;
  }
   .gmnoprint {
    div {
      zoom: .9;
    }
  }
  .gm-style img {
    width: 12px;
    height: 12px;
  }
  .gm-style-iw-d {
    padding-right: 8px;
    padding-bottom: 7px;
    overflow: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .gm-style-cc {
    display: none !important;
  }
  .gm-style {
    div {
      cursor: initial !important;
      display: flex;
      align-items: center;
      flex-direction: column;
      width: 100%;
      .div {
        width: 100%;
      }
      .rp-google-map-address {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        font-weight: 500;
      }
      .rp-google-map-address-label {
        font-size: 12px;
      }
    }
    .gm-style-iw-c {
      border-radius: 5px;
      padding: 8px;
      padding-top: 6px !important;
    }
    .gm-style-iw-t::after {
      top: -1 !important;
    }
  }
  .gm-style-iw.gm-style-iw-c {
    max-height: 43px !important;
    min-width: 150px;
    max-width: 180px !important
  }
  .gmnoprint.gm-bundled-control.gm-bundled-control-on-bottom {
    right: 32px !important;
    bottom: 70px !important;
  }
  .rp-google-map-pin-info {
    text-align: center;
    font-size: 12px;
  }
  .pin-info-shipping-address {
    font-weight: bold;
    font-size: 12px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex;
    justify-content: center;
  }
  .rp-google-map-pin-info, .pin-info-shipping-address{
    @include for-size(desktop-up){
      font-size: 16px;
    }
  }
}
</style>